define.alias("shared/utils/formatters/ig-post-from-basic-display", "settings/utils/formatters/ig-post-from-basic-display");